import { useEffect } from 'react';
import { AppRoutes } from '@/app/routes';
import { getPlatform, isNativePlatform, publicSiteUrl } from '@/lib/platform';

const EXTERNAL_PATHS: ReadonlySet<string> = new Set(Object.values(AppRoutes.legal));

/**
 * Native app only: a tap on a legal link opens the website page in the in-app
 * browser before the router sees it, so the screen underneath (a half-filled
 * sign-up form) stays mounted. The legal routes still redirect for other entries.
 */
export function useNativeExternalLinks(): void {
  useEffect(() => {
    if (!isNativePlatform()) return undefined;
    const onClick = (event: MouseEvent) => {
      if (event.defaultPrevented || event.button !== 0) return;
      const anchor = (event.target as Element | null)?.closest?.('a[href]');
      if (!(anchor instanceof HTMLAnchorElement)) return;
      const url = new URL(anchor.href, window.location.href);
      if (url.origin !== window.location.origin || !EXTERNAL_PATHS.has(url.pathname)) return;
      // Capture phase on the document: runs before React Router's Link, which then skips a prevented click.
      event.preventDefault();
      void getPlatform().browser.open(publicSiteUrl(`${url.pathname}${url.hash}`));
    };
    document.addEventListener('click', onClick, true);
    return () => document.removeEventListener('click', onClick, true);
  }, []);
}
